import { Menu, MenuItem, Position } from "@blueprintjs/core"
import CustomPopover from "components/Atoms/CustomPopover"
import CustomTag from "components/Atoms/CustomTag"
import StatusIcon from "components/Atoms/StatusIcon"
import CustomOverflowList from "components/Molecules/CustomOverflowList"
import RowSelector, { RowSelectorAll } from "components/Molecules/RowSelector"
import { useAllVehicles } from "graphql/vehicle/vehicle.hooks"
import { pick } from "lodash-es"
import React, { useMemo } from "react"
import { useDispatch } from "react-redux"
import ReactTable from "react-table"
import {
  TOGGLE_BULK_UPDATE_MODAL,
  TOGGLE_VEHICLE_OPEN,
} from "store/all-vehicles/all-vehicles.actions"
import { useSelectedVehicles } from "store/all-vehicles/all-vehicles.types"
import { PAGE_SIZE } from "store/vehicle.redux"
import { getId } from "utils/custom.utils"
import OverFlowTag from "../../scheduling-new/table/OverFlowTag"
import VehicleDialog from "../all/VehicleDialog"
import { Cell } from "../table/AssignedTable"
export default function AllVehicleTable() {
  const dispatch = useDispatch()
  const { data, loading } = useAllVehicles()

  const vehiclesMap = useMemo(
    () =>
      data?.allVehiclesDetail?.map(v => ({
        id: v?.id,
        registrationNumber: v?.registrationNumber,
      })),
    [data]
  )
  const COLUMNS = [
    {
      headerClassName: "vt-vehicle-selector-column",
      sortable: false,
      width: 60,
      Header() {
        return <RowSelectorAll path="vehicles" payload={vehiclesMap} />
      },
      Cell({ original }) {
        return (
          <span>
            <RowSelector
              path="vehicles"
              payload={pick(original, ["id", "registrationNumber"])}
            />
          </span>
        )
      },
      Footer({ data }) {
        return <span>#{data?.length ?? 0}</span>
      },
    },
    {
      className: "vt-vehicle-display",
      width: 150,
      sortable: false,
      accessor: "registrationNumber",
      Header() {
        const selected = useSelectedVehicles()
        return (
          <>
            Vehicle
            {Object.keys(selected).length > 0 && (
              <CustomTag
                interactive
                className="ml-2"
                intent="success"
                minimal
                onClick={e => {
                  dispatch({
                    type: TOGGLE_BULK_UPDATE_MODAL,
                  })
                }}
              >
                Bulk Entry
              </CustomTag>
            )}
          </>
        )
      },
      Cell({ value, original }) {
        const dispatch = useDispatch()

        return (
          <>
            <Cell
              onClick={e => {
                dispatch({
                  type: TOGGLE_VEHICLE_OPEN,
                  payload: getId(original),
                })
              }}
              title={value}
              subtitle={original?.vehicleType?.name}
            />
            <VehicleDialog vehicle={original} />
          </>
        )
      },
    },

    {
      accessor: "departments",
      Header: "Departments",
      width: 450,
      Cell({ value }) {
        return (
          <CustomOverflowList
            className="vt-departments-overflowlist items-center"
            items={value}
            visibleItemRenderer={item => (
              <div>
                <CustomTag className="mr-1" round minimal key={item?.id}>
                  {item?.name}
                </CustomTag>
              </div>
            )}
            overflowRenderer={extraDepartments => {
              return (
                <OverFlowTag
                  className="mr-2"
                  renderText={v => v?.name}
                  items={extraDepartments}
                />
              )
            }}
          />
        )
      },
    },

    {
      accessor: "status",
      Header: "Status",
      width: 90,
      Cell({ value }) {
        return (
          <StatusIcon
            values={{
              AV: { intent: "success", tooltip: "Available", text: "AV" },
              NA: { intent: "warning", tooltip: "Not Avaiable", text: "NA" },
              BR: { intent: "danger", tooltip: "Broken", text: "BR" },
              RP: { intent: "warning", tooltip: "Repairing", text: "RP" },
              OT: { intent: "none", tooltip: "On Trip", text: "OT" },
            }}
            condition={value}
          />
        )
      },
    },
    {
      accessor: "currentContract",
      Header: "Hiring Terms",
      width: 120,
      Cell({ value }) {
        return <Cell title={value?.contractType?.name ?? "NA"} />
      },
    },
    {
      accessor: "currentContract.totalOutstanding",
      Header: "Total Outstanding",
      width: 120,
      Cell({ value }) {
        return `₹ ${value ?? 0}`
      },
    },
    {
      accessor: "alerts",
      Header: "Alerts",
      Cell({ value }) {
        return (
          <>
            {value?.length > 0 ? (
              <CustomOverflowList
                items={value}
                visibleItemRenderer={item => {
                  return (
                    <div>
                      <CustomTag key={item?.message} minimal small>
                        {value?.message}
                      </CustomTag>
                    </div>
                  )
                }}
                overflowRenderer={items => {
                  return (
                    <CustomPopover
                      position={Position.BOTTOM}
                      content={
                        <Menu className="vt-overflow-list-menu">
                          {items?.map((item, index) => {
                            return (
                              <MenuItem
                                key={`${item?.message}-${index}`}
                                icon="warning-sign"
                                text={item?.message}
                              />
                            )
                          })}
                        </Menu>
                      }
                    >
                      <CustomTag
                        round={true}
                        interactive={true}
                        intent="danger"
                        minimal
                      >
                        + {items.length}
                      </CustomTag>
                    </CustomPopover>
                  )
                }}
              />
            ) : (
              <p>No Alerts!</p>
            )}
          </>
        )
      },
    },
  ]
  return (
    <div className="vt-vehicle-list-table">
      <ReactTable
        loading={loading}
        data={data?.allVehiclesDetail ?? []}
        loadingText="Fetching Schedules..."
        className="-highlight vt-schedule-table-new vt-vehicle-list-react-table"
        resizable={true}
        pageSize={PAGE_SIZE}
        showPagination={false}
        columns={COLUMNS}
      />
    </div>
  )
}
